/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetOrderExportSettingsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeOk, serializeUpdateOrderExportSettingsRequest, type ErrorResponse, type GetOrderExportSettingsResponse, type InternalErrorResponse, type Ok, type UpdateOrderExportSettingsRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/order-export-settings
 */
export interface OrderExportSettingsRequestBuilder extends BaseRequestBuilder<OrderExportSettingsRequestBuilder> {
    /**
     * Returns the custom order export formats this organization is enabled for, plus every custom format the platform implements so a settings screen can offer the full list.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetOrderExportSettingsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetOrderExportSettingsResponse | undefined>;
    /**
     * Replaces the set of custom order export formats this organization may use. Send the complete set — an empty list disables every custom format and leaves the organization with the built-in export types. A key that is not an implemented format is rejected with a 400 listing the valid keys.
     * @param body Replaces the set of custom export formats an organization may use.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateOrderExportSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Returns the custom order export formats this organization is enabled for, plus every custom format the platform implements so a settings screen can offer the full list.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Replaces the set of custom order export formats this organization may use. Send the complete set — an empty list disables every custom format and leaves the organization with the built-in export types. A key that is not an implemented format is rejected with a 400 listing the valid keys.
     * @param body Replaces the set of custom export formats an organization may use.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateOrderExportSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrderExportSettingsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/order-export-settings";
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderExportSettingsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OrderExportSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetOrderExportSettingsResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: OrderExportSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateOrderExportSettingsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
